import type { FC } from 'react';
import { ConditionFormContainer, ConditionFormContainerTitle } from '../RuleEditComponents';
import { Box } from '@mui/material';
import ConditionForm from './ConditionForm';
import type { FormConditionVariantProps } from '../../types';
import CriticalValueField from './CriticalValueField';
import TaskConditionOperator from './TaskConditionOperator';

const SingleConditionForm: FC<FormConditionVariantProps> = ({ indexCondition, indexTask, indexVariant }) => {
  return (
    <ConditionFormContainer
      indexCondition={indexCondition}
      title={
        <ConditionFormContainerTitle
          title={`Condition ${indexCondition + 1}`}
          subTitle={`Single metric`}
          indexCondition={indexCondition}
          indexTask={indexTask}
        />
      }
    >
      <ConditionForm
        indexVariant={indexVariant}
        title="Metric"
        indexCondition={indexCondition}
        indexTask={indexTask}
        field="metric"
      />
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 3, width: '100%' }}>
        <TaskConditionOperator
          indexCondition={indexCondition}
          indexTask={indexTask}
          isSingleCondition
          indexVariant={indexVariant}
        />
        <CriticalValueField indexCondition={indexCondition} indexTask={indexTask} indexVariant={indexVariant} />
      </Box>
    </ConditionFormContainer>
  );
};

export default SingleConditionForm;
